export default function removeEmptyPTags(html: string = ''): string {
	const emptyPTagRegex = /<p>(\s|<br\s*\/?>)*<\/p>/g;
	return html.replace(emptyPTagRegex, '');
}
